const players = new Set();

export function registerPlayerBridge (whisperIframe) {
    if (whisperIframe) players.add(whisperIframe);
}

export function unregisterPlayerBridge (whisperIframe) {
    players.delete(whisperIframe);
}

export function whisperToPlayers (method, payload) {
    let sent = 0;
    for (const player of players) {
        sent += 1;
        try {
            const result = player.invoke(method, payload);
            if (result && typeof result.catch === 'function') {
                result.catch(() => {});
            }
        } catch (e) {
            continue;
        }
    }
    return sent;
}
